<template>
  <AppIcon
    v-bind="$attrs"
    :name="name"
    :size="size"
    :stroke-width="strokeWidth"
    :title="title"
  />
</template>

<script lang="ts">
/**
 * Public-facing `IconName` enum. The const-record stays here (rather than
 * moving into `AppIcon.vue`) so the existing consumers that import
 * `{ IconName }` from `@/shared/ui` continue to work unchanged.
 */
export const IconName = {
  Shield: 'shield',
  ChevronUp: 'chevron-up',
  ChevronDown: 'chevron-down',
  X: 'x',
  Calendar: 'calendar',
  LayoutDetail: 'layout-detail',
  LayoutCompact: 'layout-compact',
  Sort: 'sort',
  Download: 'download',
  RotateCcw: 'rotate-ccw',
  Plus: 'plus',
  Copy: 'copy',
  Trash: 'trash',
  Save: 'save',
  Play: 'play',
  Pencil: 'pencil',
  MoreVertical: 'more-vertical',
  Filter: 'filter',
  Check: 'check',
  Move: 'move',
  Crown: 'crown',
} as const

export type IconName = (typeof IconName)[keyof typeof IconName]
</script>

<script setup lang="ts">
import AppIcon from './AppIcon.vue'
import type { AppIconProps } from './AppIcon.vue'

export interface BaseIconProps extends AppIconProps {}

withDefaults(defineProps<BaseIconProps>(), {
  size: 16,
  strokeWidth: 1.8,
  title: '',
})
</script>
